
function geometricalStiffnerMatrix(EIS, L, I, A) {
    var P = EIS[3]

    var kg = ([[P/L, 0, 0, -P/L, 0, 0],
    [0, (6*P)/(5*L), (P*L)/(10*L), 0, -(6*P)/(5*L), (P*L)/(L*10)],
    [0, (P*L)/(L*10), (2*L*L*P)/(L*15), 0, -(P*L)/(L*10), -(P*L*L)/(L*30)],
    [-P/L, 0, 0, P/L, 0, 0],
    [0, -(6*P)/(5*L), -(P*L)/(L*10), 0, (6*P)/(5*L), -(P*L)/(L*10)],
    [0, (P*L)/(L*10), -(P*L*L)/(L*30), 0, -(P*L)/(L*10), (2*L*L*P)/(L*15)]])

    return kg
}

export default geometricalStiffnerMatrix